import createIcon from '../../createIcon';

/**
 * @component @name Moving
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNzEgOS43MUwyMiAxMlY2SDE2TDE4LjI5IDguMjlMMTQuMTIgMTIuNDZDMTMuNzMgMTIuODUgMTMuMSAxMi44NSAxMi43MSAxMi40NkwxMS41NCAxMS4yOUMxMC4zNyAxMC4xMiA4LjQ3IDEwLjEyIDcuMyAxMS4yOUwyIDE2LjU5TDMuNDEgMThMOC43IDEyLjcxQzkuMDkgMTIuMzIgOS43MiAxMi4zMiAxMC4xMSAxMi43MUwxMS4yOCAxMy44OEMxMi40NSAxNS4wNSAxNC4zNSAxNS4wNSAxNS41MiAxMy44OEwxOS43MSA5LjcxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Moving = createIcon('Moving', [
  [
    'path',
    {
      d: 'M19.71 9.71L22 12V6H16L18.29 8.29L14.12 12.46C13.73 12.85 13.1 12.85 12.71 12.46L11.54 11.29C10.37 10.12 8.47 10.12 7.3 11.29L2 16.59L3.41 18L8.7 12.71C9.09 12.32 9.72 12.32 10.11 12.71L11.28 13.88C12.45 15.05 14.35 15.05 15.52 13.88L19.71 9.71Z',
      key: '2cku4j',
    },
  ],
]);

export default Moving;
